// extracted by mini-css-extract-plugin
module.exports = {"container":"SignaturePreview_container__3agrU","imageContainer":"SignaturePreview_imageContainer__VRQee","content":"SignaturePreview_content__1V1eY"};